import { useMemo, useCallback } from 'react';
import { useHistory } from 'react-router';

function createLocationQuery(queryObject) {
  const queryParams = new URLSearchParams();
  Object.keys(queryObject).forEach((key) => {
    if (typeof queryObject[key] === 'undefined') return;
    if (typeof queryObject[key] === 'string' && queryObject[key].length === 0) return;
    queryParams.set(key, queryObject[key])
  });

  const queryString = queryParams.toString();
  return queryString ? `?${queryString}` : '';
}

function parseLocationQuery(queryString) {
  const queryParams = new URLSearchParams(queryString);
  return [...queryParams.keys()].reduce((acc, key) => {
    const value = queryParams.getAll(key);
    acc[key] = value.length > 1
      ? value
      : value[0] || true;
    return acc;
  }, {});
}

const useLocationQuery = () => {
  const history = useHistory();

  const { search } = history.location;
  const query = useMemo(() => parseLocationQuery(search), [search]);
  const changeLocationQuery = useCallback(
    (newQueryObject) => {
      history.push({
        path: history.location.pathname,
        search: createLocationQuery(newQueryObject)
      });
    },
    [history]
  );

  return { changeLocationQuery, query };
};

export default useLocationQuery;
